/**
 * The TV's How to Play button (Cole, 2026-10-15: "apple tv Baseball needs a
 * button for rules"). Select on the Siri Remote, or H on tv.lagking.com,
 * asks the phone to open or close the game's How to Play, which it already
 * shows on the TV. Mirrored by app/LagKing/src/tv/commands.ts
 * (TV_MODE_RULES_MENU_ID); an older phone ignores the request.
 */
import type { TvRequestedCommand, TvSnapshot } from './protocol';

export const MODE_RULES_MENU_ID = 'mode.rules';

export function modeRulesCommand(): TvRequestedCommand {
  return { kind: 'menu-select', menuId: MODE_RULES_MENU_ID, optionId: 'toggle' };
}

/** Offered while a game is on (the games publish `game`). */
export function modeRulesAvailable(snapshot: TvSnapshot | null | undefined): boolean {
  return Boolean(snapshot?.game);
}

export function isModeRulesKey(key: string): boolean {
  return key === 'h' || key === 'H' || key === '?';
}
